import { render, staticRenderFns } from "./EditSetForm.vue?vue&type=template&id=b4d5b7a4"
import script from "./EditSetForm.vue?vue&type=script&lang=js"
export * from "./EditSetForm.vue?vue&type=script&lang=js"
import style0 from "./EditSetForm.vue?vue&type=style&index=0&id=b4d5b7a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports